const post = async (url: string, data: any) => {
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (res.status !== 200) {
        throw new Error(`Error while posting ${url}`);
    }

    return res.json();
};

export default post;
